<template>
  <div class="panel panel-default">
    <div class="panel-heading" :title="cid.descricaoAbreviada">
      {{ caixaAlta(limitar(cid.descricaoAbreviada, 5)) }}
    </div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr :title="cid.descricaoAbreviada">
            <td><strong>Descrição</strong></td>
            <td>
              {{ limitar(iniciarEm(cid.descricaoAbreviada, 5), 40) }}
            </td>
          </tr>
          <tr>
            <td><strong>Situação</strong></td>
            <td :class="cid.ativo ? 'text-success' : 'text-danger'">{{
              cid.ativo ? 'Ativo' : 'Cancelado'
            }}</td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          id="botaoEditar"
          data-test-id="link-botaoeditar"
          :to="'/cid/cadastro/' + cid._id"
          name="botaoEditar"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-edit" /> Editar
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'CidFicha',
  props: {
    cid: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
